/**
 * Modular Add-ons — collapsible dropdown + checkbox sync + submit handling.
 * Self-contained: intercepts the product form submit when present,
 * collects checked addon variant IDs, and sends them as a batch /cart/add.
 */
(function () {
  'use strict';

  /* ---- Collapsible ---- */

  function initCollapsible(container) {
    var list = container.querySelector('[data-modular-addons-list]');
    var toggleBtn = container.querySelector('[data-modular-addons-toggle]');
    if (!list || !list.hasAttribute('data-collapsible')) return;

    var visibleCount = parseInt(list.getAttribute('data-visible-count'), 10) || 3;
    var items = list.querySelectorAll('[data-ps-modular-addon]');

    // Mark items beyond visible count as collapsed
    for (var i = 0; i < items.length; i++) {
      if (i >= visibleCount) {
        items[i].setAttribute('data-addon-collapsed', '');
      }
    }

    // Hide toggle if all items fit
    if (items.length <= visibleCount && toggleBtn) {
      toggleBtn.style.display = 'none';
      return;
    }

    if (!toggleBtn) return;

    toggleBtn.addEventListener('click', function () {
      var expanded = list.hasAttribute('data-expanded');
      if (expanded) {
        list.removeAttribute('data-expanded');
        toggleBtn.setAttribute('aria-expanded', 'false');
        toggleBtn.querySelector('[data-collapse-label]').hidden = false;
        toggleBtn.querySelector('[data-expand-label]').hidden = true;
      } else {
        list.setAttribute('data-expanded', '');
        toggleBtn.setAttribute('aria-expanded', 'true');
        toggleBtn.querySelector('[data-collapse-label]').hidden = true;
        toggleBtn.querySelector('[data-expand-label]').hidden = false;
      }
    });
  }

  /* ---- ATC button — per-item direct add ---- */

  /** @type {Record<string, string>} */
  var ATC_ICONS = {
    plus: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
    cart: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M1 1.5h2.4l2 6.5h6.8l1.8-4.5H4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="7" cy="13" r="1.25" fill="currentColor"/><circle cx="12" cy="13" r="1.25" fill="currentColor"/></svg>',
    bag: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M5.5 6V4.5a2.5 2.5 0 015 0V6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><rect x="2" y="6" width="12" height="8" rx="2" stroke="currentColor" stroke-width="1.5"/></svg>',
    arrow: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  };

  /** @param {HTMLElement} container */
  function initAtcButtons(container) {
    if (container.dataset.interactionMode !== 'atc_button') return;

    var label = container.dataset.atcLabel || 'Add to cart';
    var iconKey = container.dataset.atcIcon || 'none';
    var iconPosition = container.dataset.atcIconPosition || 'before';
    var iconSvg = iconKey !== 'none' ? ATC_ICONS[iconKey] || '' : '';

    container.querySelectorAll('[data-addon-atc]').forEach(function (btn) {
      var btnEl = /** @type {HTMLElement} */ (btn);

      // Clear any previously injected icons (theme editor re-renders)
      btnEl.querySelectorAll('.ps-modular-addon__atc-icon').forEach(function (el) { el.remove(); });

      var labelSpan = btnEl.querySelector('.ps-modular-addon__atc-label');
      if (labelSpan) labelSpan.textContent = label;

      if (!iconSvg) return;

      var iconWrap = document.createElement('span');
      iconWrap.className = 'ps-modular-addon__atc-icon';
      iconWrap.setAttribute('aria-hidden', 'true');
      iconWrap.innerHTML = iconSvg;

      if (iconPosition === 'after') {
        btnEl.appendChild(iconWrap);
      } else {
        btnEl.insertBefore(iconWrap, btnEl.firstChild);
      }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-addon-atc]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.getAttribute('aria-disabled') === 'true') return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var labelSpan = btn.querySelector('.ps-modular-addon__atc-label');
    var originalText = labelSpan ? labelSpan.textContent : '';
    var card = btn.closest('[data-ps-modular-addon]');
    var isFree = card && !!card.querySelector('.ps-modular-addon__price--free');

    btn.setAttribute('aria-disabled', 'true');
    if (labelSpan) labelSpan.textContent = 'Add';

    var item = {
      id: parseInt(variantId, 10),
      quantity: 1,
      properties: { _addon: 'true' },
    };
    if (isFree) item.properties._free_gift = 'true';

    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });
    var payload = { items: [item] };
    if (sectionIds.length) payload.sections = sectionIds.join(',');

    fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          if (labelSpan) labelSpan.textContent = originalText;
          btn.removeAttribute('aria-disabled');
          return;
        }
        if (labelSpan) labelSpan.textContent = '\u2713';
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (cr) { return cr.json(); })
          .then(function (cartData) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                source: 'modular-addons-atc',
                data: { itemCount: cartData.item_count, sections: response.sections },
              },
            }));
          });
        setTimeout(function () {
          if (labelSpan) labelSpan.textContent = originalText;
          btn.removeAttribute('aria-disabled');
        }, 2000);
      })
      .catch(function () {
        if (labelSpan) labelSpan.textContent = originalText;
        btn.removeAttribute('aria-disabled');
      });
  });

  /* ---- Info panel toggle ---- */

  document.addEventListener('click', function (e) {
    var infoBtn = e.target.closest('[data-addon-info-trigger]');
    if (!infoBtn) return;
    e.preventDefault();
    e.stopPropagation();

    var addon = infoBtn.closest('[data-ps-modular-addon]');
    if (!addon) return;
    var panel = addon.querySelector('[data-addon-info-panel]');
    if (!panel) return;
    panel.hidden = !panel.hidden;
  });

  /* ---- Checkbox sync ---- */

  document.addEventListener('change', function (e) {
    if (!e.target.matches('.ps-modular-addon__input')) return;
    var card = e.target.closest('[data-ps-modular-addon]');
    if (!card) return;

    var isChecked = e.target.checked;
    card.setAttribute('aria-checked', isChecked ? 'true' : 'false');
    card.setAttribute('data-ps-contributor-active', isChecked ? 'true' : 'false');

    // Sync duplicate cards with same variant ID across page
    var variantId = card.getAttribute('data-addon-variant-id');
    if (variantId) {
      document
        .querySelectorAll('[data-ps-modular-addon][data-addon-variant-id="' + variantId + '"]')
        .forEach(function (sibling) {
          if (sibling === card) return;
          sibling.setAttribute('aria-checked', isChecked ? 'true' : 'false');
          sibling.setAttribute('data-ps-contributor-active', isChecked ? 'true' : 'false');
          var siblingInput = sibling.querySelector('.ps-modular-addon__input');
          if (siblingInput && siblingInput !== e.target) {
            siblingInput.checked = isChecked;
          }
        });
    }

    // Update price contributors if the function is available
    var details = card.closest('.product-details') || card.closest('.shopify-section');
    if (details && typeof window.updatePrices === 'function') {
      window.updatePrices(details);
    }
    if (details && typeof window.updateTotalBarFromContributors === 'function') {
      window.updateTotalBarFromContributors(details);
    }
  });

  /* ---- Collect active addons ---- */

  function getActiveModularAddons(container) {
    var addons = [];
    var seen = {};
    if (!container) return addons;

    container.querySelectorAll('[data-ps-modular-addon]').forEach(function (card) {
      var checkbox = card.querySelector('.ps-modular-addon__input');
      if (!checkbox || !checkbox.checked) return;

      var variantId = card.getAttribute('data-addon-variant-id');
      if (!variantId || seen[variantId]) return;
      seen[variantId] = true;

      addons.push({
        variantId: variantId,
        isFree: !!card.querySelector('.ps-modular-addon__price--free'),
      });
    });

    return addons;
  }

  /* ---- Submit handling ---- */

  function handleModularAddonSubmit(e, form) {
    e.preventDefault();
    e.stopImmediatePropagation();

    var details = form.closest('.product-details') || form.closest('.shopify-section');

    // Validate variant selection
    var section = details || form.closest('.shopify-section');
    var variantPicker = section ? section.querySelector('variant-picker') : null;
    if (variantPicker && variantPicker.validateSelection && !variantPicker.validateSelection()) return;

    var addons = getActiveModularAddons(details);

    var variantInput = form.querySelector('input[name="id"]');
    if (!variantInput || !variantInput.value) return;

    var quantityInput = form.querySelector('input[name="quantity"]');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    var mainItem = {
      id: parseInt(variantInput.value, 10),
      quantity: quantity,
    };

    var sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    if (sellingPlanInput && sellingPlanInput.value) {
      mainItem.selling_plan = parseInt(sellingPlanInput.value, 10);
    }

    // Inject offer.cart_text
    var cartTextMapEl = (details.closest('.shopify-section') || document).querySelector('[data-cart-text-map]');
    if (cartTextMapEl) {
      try {
        var cartTextMap = JSON.parse(cartTextMapEl.textContent);
        var cartText = cartTextMap[variantInput.value] || cartTextMap['_product'] || '';
        if (cartText) {
          if (!mainItem.properties) mainItem.properties = {};
          mainItem.properties['Details'] = cartText;
        }
      } catch (ex) {
        /* ignore */
      }
    }

    var items = [mainItem];

    var productFormComponent = form.closest('product-form-component');
    var parentProductId = productFormComponent ? productFormComponent.dataset.productId || '' : '';

    for (var a = 0; a < addons.length; a++) {
      var addonItem = {
        id: parseInt(addons[a].variantId, 10),
        quantity: 1,
        properties: { _addon: 'true', _addon_parent: parentProductId },
      };
      if (addons[a].isFree) {
        addonItem.properties._free_gift = 'true';
      }
      items.push(addonItem);
    }

    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) {
        sectionIds.push(el.dataset.sectionId);
      }
    });

    var payload = { items: items };
    if (sectionIds.length > 0) {
      payload.sections = sectionIds.join(',');
    }

    // Animate the add-to-cart button
    var addToCartComponent = form.querySelector('add-to-cart-component');
    if (addToCartComponent && addToCartComponent.animateAddToCart) {
      addToCartComponent.animateAddToCart();
    }

    fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (response) {
        if (response.status) {
          if (addToCartComponent && addToCartComponent.resetButton) addToCartComponent.resetButton();
          return;
        }

        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (cr) {
            return cr.json();
          })
          .then(function (cartData) {
            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  source: 'modular-addons',
                  data: { itemCount: cartData.item_count, sections: response.sections },
                },
              })
            );
          });
      })
      .catch(function (err) {
        console.warn('Modular add-ons submit error:', err);
        if (addToCartComponent && addToCartComponent.resetButton) addToCartComponent.resetButton();
      });
  }

  /* ---- Init ---- */

  function init() {
    var containers = document.querySelectorAll('[data-ps-modular-addons]');

    containers.forEach(function (container) {
      if (container.hasAttribute('data-modular-addons-init')) return;
      container.setAttribute('data-modular-addons-init', '');

      // Collapsible
      initCollapsible(container);

      // ATC button labels
      initAtcButtons(/** @type {HTMLElement} */ (container));

      // Submit interception
      var details = container.closest('.product-details') || container.closest('.shopify-section');
      if (!details) return;

      // Don't intercept if bundle cards or existing cart-addons already handle submit
      if (details.querySelector('[data-ps-bundle-cards]')) return;
      if (details.querySelector('[data-ps-cart-addons]')) return;

      var productFormComp = details.querySelector('product-form-component[on\\:submit]');
      if (productFormComp) {
        productFormComp.setAttribute('data-original-on-submit', productFormComp.getAttribute('on:submit'));
        productFormComp.removeAttribute('on:submit');
      }

      var form = details.querySelector('form[action*="/cart/add"]');
      if (form && !form.hasAttribute('data-modular-addon-submit-bound')) {
        form.setAttribute('data-modular-addon-submit-bound', '');
        form.addEventListener('submit', function (e) {
          handleModularAddonSubmit(e, form);
        });
      }
    });
  }

  // Run on DOM ready and on Shopify section render events
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
